import { render, staticRenderFns } from "./ReprintBill.vue?vue&type=template&id=5becc9d0&scoped=true&"
import script from "./ReprintBill.vue?vue&type=script&lang=js&"
export * from "./ReprintBill.vue?vue&type=script&lang=js&"
import style0 from "./ReprintBill.vue?vue&type=style&index=0&id=5becc9d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5becc9d0",
  null
  
)

export default component.exports